import React from "react";
const resumeFile =
  "https://docs.google.com/document/d/1b1xevbEdrLgLHXnWw8LkueqFhiPoVew4Jfkwr3eZ4H0/export?format=pdf";

const Resume = ({ classicHeader, darkTheme }) => {
  const educationDetails = [
    {
      yearRange: "2019 - 2021",
      title: "Computer Science",
      place: "Federal Polytechnic Ilaro, Nigeria",
      desc: "Higher National Diploma in Computer Science.",
    },
    {
      yearRange: "2014 - 2016",
      title: "Computer Science",
      place: "Federal College of Animal Health Production",
      desc: "National Diploma in Computer Science.",
    },
    {
      yearRange: "2007 - 2013",
      title: "SSCE",
      place: "Government College Ibadan",
      desc: "Science.",
    },
  ];

  const experienceDetails = [
    {
      yearRange: "2024",
      title: "WordPress Engineer | Automation & Backend Engineer",
      place: "Bellviv Professionals | Australia (Remote)",
      desc:[ "• Engineer custom backend solutions, REST API integrations, plugins, and scalable systems supporting enterprise and multi-site environments.",
"• Develop and integrate REST APIs connecting SaaS platforms, internal systems, and microservices architectures.",
"• Automate deployments, recurring server operations, and database migrations using Python, Bash, and custom scripting, reducing manual workload by 40%.",
"• Build CI/CD workflows using GitHub Actions and Docker to improve deployment reliability and release efficiency.",
    ],
  },
    {
      yearRange: "2023 - 2024",
      title: "Software Engineer",
      place: "Untye Africa | Nigeria (Remote)",
      desc: ["Develop and maintaining financial web apps for financial institution (ReactJS, Python, Google Cloud and PostgreSql).",
        "• Developed and maintained financial web applications using Django, PostgreSQL, ReactJS, and Google Cloud.",
"• Built modular backend features and API-driven functionality for financial application workflows.",
"• Optimized SQL queries and backend processes to improve API response times and application performance.",
"• Contributed to backend architecture and system design, focusing on maintainability and scalability."
      ],
    },
    {
      yearRange: "2021 - 2023",
      title: "Full Stack Developer | IT Specialist",
      place: "Ash Xander Ltd | Nigeria",
      desc: ["Develop Website, Web Portal for clients using the latest technologies (PHP & Woocormmerce, CakePHP).",
        "• Designed, developed, deployed, and maintained cloud-based applications using PHP, CakePHP, Laravel, and DigitalOcean.",
"• Developed backend-driven web applications and enterprise platforms supporting business workflows and operational requirements.",
"• Built and maintained e-commerce platforms using PHP, WooCommerce, and WordPress.",
      ],
    },
    {
      yearRange: "2018 - 2020",
      title: "Web Developer",
      place: "Ufitfly Ltd",
      desc: "Design and implementation of corporate website and blog (WordPress & PHP).",
    },
  ];

  // const skills = [
  //   {
  //     name: "Web Development",
  //     // percent: 85,
  //   },
  //   {
  //     name: "Mobile Development",
  //     // percent: 90,
  //   },
  //   {
  //     name: "HTML/CSS/JS/AJAX",
  //     // percent: 95,
  //   },
  //   {
  //     name: "JavaScript",
  //     // percent: 80,
  //   },
  //   {
  //     name: "React JS",
  //     // percent: 70,
  //   },
  //   {
  //     name: "Django Rest Framework",
  //     // percent: 70,
  //   },
  //   {
  //     name: "GCP, DigitalOcean, AWS",
  //     // percent: 99,
  //   },
  //   {
  //     name: "WordPress CMS",
  //     // percent: "90"
  //   },
  //   {
  //     name: "Media Content Developer",
  //     // percent: "87"
  //   },
  //   {
  //     name:"Data Science"
  //   },
  // ];

  return (
    <section
      id="resume"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Summary
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Resume
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gx-5">
          {/* My Education */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Education
            </h2>
            {educationDetails.length > 0 &&
              educationDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
          {/* My Experience */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Experience
            </h2>
            {experienceDetails.length > 0 &&
              experienceDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
        </div>
        {/* My Skills
        <h2
          className={
            "text-6 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")
          }
        >
          My Skills
        </h2>
        <div className="row gx-5">
          {skills.length > 0 &&
            skills.map((skill, index) => (
              <div key={index} className="col-md-6">
                <p
                  className={
                    " fw-500 text-start mb-2 " +
                    (darkTheme ? "text-light" : "text-dark")
                  }
                >
                  {skill.name}{" "}
                  <span className="float-end">{skill.percent}</span>
                </p>
                <div
                  className={
                    "progress progress-sm mb-4 " + (darkTheme ? "bg-dark" : "")
                  }
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: skill.percent + "%" }}
                    aria-valuenow={skill.percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            ))}
        </div> */}
        <div className="text-center mt-5">
          <a
            className="btn btn-outline-secondary rounded-pill shadow-none"
            href={resumeFile}
          >
            Download CV
            <span className="ms-1">
              <i className="fas fa-download" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Resume;
